/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-payment-gateway.reducer';

export const TenantPaymentGatewayDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantPaymentGatewayEntity = useAppSelector(state => state.tenantPaymentGateway.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantPaymentGatewayDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.detail.title">TenantPaymentGateway</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantPaymentGatewayEntity.id}</dd>
          <dt>
            <span id="merchantId">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.merchantId">Merchant Id</Translate>
            </span>
            <UncontrolledTooltip target="merchantId">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.merchantId}</dd>
          <dt>
            <span id="merchantKey">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.merchantKey">Merchant Key</Translate>
            </span>
            <UncontrolledTooltip target="merchantKey">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantKey" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.merchantKey}</dd>
          <dt>
            <span id="merchantKeyIndex">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.merchantKeyIndex">Merchant Key Index</Translate>
            </span>
            <UncontrolledTooltip target="merchantKeyIndex">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantKeyIndex" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.merchantKeyIndex}</dd>
          <dt>
            <span id="apiVersion">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.apiVersion">Api Version</Translate>
            </span>
            <UncontrolledTooltip target="apiVersion">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.apiVersion" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.apiVersion}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.draft">Draft</Translate>
            </span>
            <UncontrolledTooltip target="draft">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.draft" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantPaymentGatewayEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.timestampEntry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.addedById">Added By Id</Translate>
            </span>
            <UncontrolledTooltip target="addedById">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.addedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.modifiedById">Modified By Id</Translate>
            </span>
            <UncontrolledTooltip target="modifiedById">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.modifiedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.addedByType">Added By Type</Translate>
            </span>
            <UncontrolledTooltip target="addedByType">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.addedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.modifiedByType">Modified By Type</Translate>
            </span>
            <UncontrolledTooltip target="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.modifiedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.modifiedByType}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.tenantId">Tenant Id</Translate>
            </span>
            <UncontrolledTooltip target="tenantId">
              <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.tenantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantPaymentGatewayEntity.tenantId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.gateway">Gateway</Translate>
          </dt>
          <dd>{tenantPaymentGatewayEntity.gateway ? tenantPaymentGatewayEntity.gateway.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-payment-gateway" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-payment-gateway/${tenantPaymentGatewayEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantPaymentGatewayDetail;
